import React, {Component} from "react"
import {connect} from "react-redux";
import withStyles from "@mui/styles/withStyles";
import {withRouter} from "react-router-dom";
import {get_settings, save_settings} from "../actions/coupons";
import LinearProgress from "@mui/material/LinearProgress";
import {Box, Button, FormControl} from "@mui/material";
import Typography from "@mui/material/Typography";
import SnackbarMessage from "./Custom/SnackbarMessage";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

const styles = {
    paper: {
        margin: 15
    },
    fab: {
        position: 'absolute',
        bottom: "40px",
        right: "20px",
    },
};


class Settings extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            used_free_characters: 0,
            free_pool_limit: 0,
            error: null
        }
    }

    componentDidMount() {
        this.refreshSettings();
    }

    refreshSettings() {
        get_settings().then(r => {
            this.setState({
                ...this.state,
                loading: false,
                used_free_characters: r.data.used_free_characters,
                free_pool_limit: r.data.free_pool_limit
            });
        });
    }

    onSubmit(e) {
        e.preventDefault();
        save_settings(
            this.state.used_free_characters,
            this.state.free_pool_limit
        ).then(res => {
            this.refreshSettings();
        }).catch(err => {

            this.setState({
                ...this.state,
                error: Object.values(err.response.data.errors).join(", ")
            });
        });
    }

    onChange = e => this.setState({
        ...this.state,
        [e.target.name]: e.target.value,
    });

    clearError() {
        this.setState({
            ...this.state,
            error: null
        });
    }

    render() {
        if (this.state.loading) {
            return <LinearProgress/>
        }
        const {classes} = this.props;
        return (<Box className={classes.paper}>
            <Typography variant={"h5"}
                        style={{marginBottom: 30}}>Settings</Typography>
            {this.state.error && <SnackbarMessage onClose={this.clearError.bind(this)} type="error"
                                                  message={this.state.error} autoHideDuration={null}
                                                  anchorOrigin={false}
                                                  style={{marginBottom: 30}}/>}
            <form onSubmit={this.onSubmit.bind(this)} method="post">
                <Grid container spacing={2}
                      justifyContent="flex-end">
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth
                                   variant="standard"
                                   label="Free pool usage"
                                   type="number"
                                   name="used_free_characters" onChange={this.onChange}
                                   value={this.state.used_free_characters}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth
                                   variant="standard"
                                   label="Free pool limit"
                                   type="number"
                                   name="free_pool_limit" onChange={this.onChange} value={this.state.free_pool_limit}
                        />
                    </Grid>
                    <Grid item xs={12} style={{
                        display: "flex",
                        justifyContent: "flex-end"
                    }}>
                        <FormControl>
                            <Button variant="contained"
                                    onClick={this.onSubmit.bind(this)}
                                    color="secondary"
                                    type="submit"
                            >Save</Button>
                        </FormControl>
                    </Grid>
                </Grid>
            </form>
        </Box>)
    }
}

const mapStateToProps = state => ({});

export default withRouter(withStyles(styles)(connect(
    mapStateToProps,
    {}
)(Settings)));
